import { Box, Image, Spacer, Text } from '@dtx-company/shared-components/src'
import { LargeProductSuitCardData } from '../types'
import { prismicCachedImage } from '@app/prismic/src/utils'
import React from 'react'

const ValuePropsColumns: React.FC<{
  valuePropsText: LargeProductSuitCardData['value_props_list']
  valuePropsImages: LargeProductSuitCardData['value_props_images']
}> = ({ valuePropsText, valuePropsImages }) => {
  if (!valuePropsText || !valuePropsImages) return null
  const imageSrcs = valuePropsImages.map(image => ('text' in image ? image.text : ''))
  const texts = valuePropsText.map(field => ('text' in field ? field.text : ''))
  return (
    <Box
      maxWidth={{ _: '425px', md: '315px' }}
      display={{ _: 'grid' }}
      gridTemplateColumns={`repeat(${texts.length}, 1fr)`}
    >
      {texts?.map((text, idx) => {
        return (
          <Box key={text} flexDirection="column" alignItems="center" mx="4px">
            <Image src={prismicCachedImage(imageSrcs[idx])} alt="" width="20px" height="20px" />
            <Spacer mb="8px" />
            <Text textAlign="center">{text}</Text>
          </Box>
        )
      })}
    </Box>
  )
}

export default ValuePropsColumns
